import { useEffect } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { Horizontal, SBHorizontal, Vertical } from 'atoms/layout/flex';
import { HeadlineS, LabelM, LabelS } from 'atoms/typography';
import { useBrazeContext } from 'contexts/braze';
import { BrazeCard } from 'contexts/braze/types';
import { Link } from 'routing/Link';

const Root = styled(Vertical)`
  position: relative;
  isolation: isolate;
  border-radius: var(--double-unit);
  border: 1px solid;
  padding: var(--double-unit);

  background: center right / cover no-repeat var(--bg);
  background-color: var(--c-neutral-200);
`;
const Description = styled(LabelM)`
  max-width: 70%;
`;
const Icon = styled.img`
  position: absolute;
  bottom: var(--unit);
  right: var(--unit);
  width: var(--triple-unit);
  height: var(--triple-unit);
`;
const Badge = styled(Horizontal).attrs({ center: true })`
  border-radius: var(--unit);
  background-color: var(--c-neutral-400);
  padding: 2px var(--unit);
`;
const StyledLink = styled(Link)`
  &,
  &:hover {
    color: inherit;
  }
`;

type Props = { card: BrazeCard };
export const BannerV1ContentCard = ({ card }: Props) => {
  const { api } = useBrazeContext();
  const { description, title, extras, url } = card;
  const { customEvent } = extras;
  const { height, badge, iconURL, borderColor, backgroundURL } = extras;

  useEffect(() => {
    if (api && card) {
      api.logContentCardImpressions([card]);
    }
  }, [api, card]);

  const onClick = () => {
    api?.logContentCardClick(card);
    if (customEvent) {
      api?.logCustomEvent(customEvent);
    }
  };

  if (!url && !customEvent) {
    return null;
  }

  const content = (
    <Root
      onClick={onClick}
      style={
        {
          height,
          borderColor,
          '--bg': `url(${backgroundURL})`,
        } as CSSProperties
      }
      gap={3}
    >
      <SBHorizontal gap={3}>
        <HeadlineS as="h2">{title}</HeadlineS>
        {badge && (
          <Badge>
            <LabelS as="span">{badge}</LabelS>
          </Badge>
        )}
      </SBHorizontal>

      <Description as="p">{description}</Description>
      <Icon src={iconURL} alt="" />
    </Root>
  );

  if (!url) {
    return content;
  }

  return <StyledLink to={url}>{content}</StyledLink>;
};
